<template>
<section class="main">
  <div class="content_page_title">
    <h1>Paramétrages</h1>
  </div>
  <div class="main_content">
    <form method="" action="">
      <div class="form">
        <div class="form_message">
          <div class="form_message_text"> Configurez vos préférences et recevez des alertes par mail lorsqu'un incident est détecté sur une antenne appartenant à votre zone géographique. </div>
        </div>
      </div>
    </form>
    <h2>Lieux surveillés</h2>
    <div class="row">
      <form ref="lieuxForm" v-on:submit.prevent>
        <table>
          <thead>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Rayon (km)</th>
            <th>Action</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in listeLieux" :key="index">
              <td data-label="Latitude">{{item.latitude}}</td>
              <td data-label="Longitude">{{item.longitude}}</td>
              <td data-label="Rayon (km)">{{item.rayon}}</td>
              <td data-label="Action">
                <button @click="deleteLieuSurveillance(item.id)" class="button_suppr">Supprimer</button>
              </td>
            </tr>
            <tr>
              <td>
                <input type="text" name="latitude" id="latitude" v-model="formLatitude" pattern="^-?\d*\.?\d*$" placeholder="Latitude" required>
              </td>
              <td>
                <input type="text" name="longitude" id="longitude" v-model="formLongitude" pattern="^-?\d*\.?\d*$" placeholder="Longitude" required>
              </td>
              <td>
                <input type="number" min="1" name="rayon" id="rayon" v-model="formRayon" placeholder="Rayon (km)" required>
              </td>
              <td>
                <button class="button_add" @click="addLieuSurveille">Ajouter</button>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
    <h2>Message d'information</h2>
    <div class="row">
      <h3>Activer Notification: </h3>
      <div class="onoffswitch">
        <input type="checkbox" class="onoffswitch-checkbox" id="switchTnt" v-model="formNotificationTnt">
        <label class="onoffswitch-label" for="switchTnt">
          <span class="onoffswitch-inner"></span>
          <span class="onoffswitch-switch"></span>
        </label>
      </div>
    </div>
    <div class="line rowText">
      <p>Si la notification est activée, vous recevrez une notification par mail lorsqu’un message d’information (à destination de l’assistance TNT ) est activé dans l’une de vos zones de surveillance.</p>
    </div>
    <h2>Nouvelles antennes 4G</h2>
    <div class="row">
      <h3>Activer Notification: </h3>
      <div class="onoffswitch">
        <input type="checkbox" class="onoffswitch-checkbox" id="switchLte" v-model="formNotificationLte">
        <label class="onoffswitch-label" for="switchLte">
          <span class="onoffswitch-inner"></span>
          <span class="onoffswitch-switch"></span>
        </label>
      </div>
    </div>
    <div class="row formRow">
      <h3>Nombre de jours: </h3>
      <input type="number" min="1" max="365" name="nbJours" id="nbJours" v-model="formNbJoursNotificationLte" required>
    </div>
    <div class="line rowText">
      <p>Si la notification est activée, vous recevrez une notification <strong>{{formNbJoursNotificationLte > 0 ? formNbJoursNotificationLte : 'X'}}</strong> jours avant la mise en service d’une station 4G située dans l'une de vos zones de
        surveillance.</p>
    </div>
    <div class="modal_footer line">
      <button class="button blue" @click="onValidate">Enregistrer</button>
    </div>
    <div class="modal_footer line">
      <a href="index.html" class="button dark">Retour à l'accueil</a>
    </div>
  </div>
</section>
</template>

<script>
import axios from 'axios'
import storeJs from 'store'
export default {
  name: 'Parametrage',
  components: {},
  data() {
    return {
      listeLieux: [],
      idUtilisateur: storeJs.get('prtv:user-id'),
      formLatitude: storeJs.get('prtv:lat'),
      formLongitude: storeJs.get('prtv:lon'),
      formRayon: null,
      idUser: storeJs.get('prtv:user-id'),
      formNotificationTnt: storeJs.get('prtv:user-notificationTnt'),
      formNotificationLte: storeJs.get('prtv:user-notificationLte'),
      formNbJoursNotificationLte: storeJs.get('prtv:user-nbJoursNotificationLte')
    }
  },
  /*filters: {
    handleMissingValue(value) {
      return (value != null && value.length > 0) ? value : "Non renseigné";
    }
  },*/
  created() {
    this.idUtilisateur = storeJs.get('prtv:user-id');
  },
  destroyed() {
    document.body.classList.remove('hamburger_menu');
    this.idUtilisateur = null;
    this.formLatitude = null,
      this.formLongitude = null,
      this.formRayon = null
  },
  mounted() {
    document.body.classList.add('hamburger_menu');
    this.$store.state.menu.active = false;
    this.getLieuSurveillance();
  },
  methods: {
    addLieuSurveille() {
      if (this.$refs['lieuxForm'].checkValidity()) {
        axios.post('/lieusurveillance', {
          lon: this.formLongitude,
          lat: this.formLatitude,
          rayon: this.formRayon,
          idUtilisateur: this.idUtilisateur
        }).then(response => {
          this.listeLieux.push(response.data);
          this.$refs['lieuxForm'].reset();
          this.formLatitude = storeJs.get('prtv:lat');
          this.formLongitude = storeJs.get('prtv:lon');
          this.formRayon = null;
        });
      }
    },
    getLieuSurveillance() {
      axios.get('/lieusurveillance', {
        params: {
          idUtilisateur: this.idUtilisateur
        }
      }).then(response => {
        this.listeLieux = response.data;
      })
    },
    deleteLieuSurveillance(id) {
      axios.delete('/lieusurveillance', {
        params: {
          idLieuSurveillance: id
        }
      }).then(() => {
        this.listeLieux.splice(this.listeLieux.findIndex(l => l.id === id), 1);
        this.$refs['lieuxForm'].reset();
        this.formLatitude = storeJs.get('prtv:lat');
        this.formLongitude = storeJs.get('prtv:lon');
        this.formRayon = null;
      })
    },
    // Sauvegarde des paramètres
    onValidate() {
      if (this.formNotificationTnt != null && this.formNotificationLte != null && this.formNbJoursNotificationLte > 0 && this.formNbJoursNotificationLte <= 365) {
        axios.post('/utilisateur/updateParametres', {
          idUser: this.idUser,
          notificationTnt: this.formNotificationTnt,
          notificationLte: this.formNotificationLte,
          nbJoursNotificationLte: this.formNbJoursNotificationLte
        }).then(() => {
          // Prise en compte dans la session courante
          storeJs.set('prtv:user-notificationTnt', this.formNotificationTnt);
          storeJs.set('prtv:user-notificationLte', this.formNotificationLte);
          storeJs.set('prtv:user-nbJoursNotificationLte', this.formNbJoursNotificationLte);
          this.$notify({
            group: 'general-notification',
            type: 'success',
            text: "Vos paramètres ont bien été enregistrés"
          });
        });
      }
    }
  }
}
</script>

<style scoped>
h2 {
  margin-left: 20px;
  margin-top: 30px;
  color: #007ABC;
}

.main_content {
  display: block !important;
}

.line {
  display: flex;
  justify-content: space-around;
}

.row {
  display: flex;
  justify-content: space-around;
}

.button_suppr {
  color: #d9534f;
}

.button_add {
  color: #5cb85c;
}

.column_lieux {}

.onoffswitch {
  position: relative;
  width: 75px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #999999;
  border-radius: 22px;
}

.onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}

.onoffswitch-inner:before,
.onoffswitch-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 26px;
  padding: 0;
  line-height: 26px;
  font-size: 14px;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  box-sizing: border-box;
}

.onoffswitch-inner:before {
  content: "OUI";
  padding-left: 10px;
  background-color: #007ABC;
  color: #FFFFFF;
}

.onoffswitch-inner:after {
  content: "NON";
  padding-right: 10px;
  background-color: #EEEEEE;
  color: #999999;
  text-align: right;
}

.onoffswitch-switch {
  display: block;
  width: 14px;
  margin: 6px;
  height: 14px;
  background: #FFFFFF;
  position: absolute;
  top: 2px;
  bottom: 0;
  right: 45px;
  border: 2px solid #999999;
  border-radius: 22px;
  transition: all 0.3s ease-in 0s;
}

.onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
  right: 0px;
}

.rowText {
  margin: 0 20% 0 20%;
}

.formRow input {
  max-height: 30px;
  max-width: 100px;
}

h3 {
  color: rgb(100, 100, 100);
}

.saveButton {
  background-color: #5cb85c;
}

@media (max-width: 800px) {
  .row table thead {
    display: none;
  }

  .row table tr {
    display: block;
    margin-bottom: 10px;
  }

  .row table tr:last-child td {
    border-bottom: none;
    padding-top: 10px;
    padding-bottom: 30px;
  }

  .row table td {
    display: block;
    text-align: right;
    height: 32px;
    border-bottom: 1px solid rgb(200, 200, 200);
    padding: 0 10px 0 10px;
    vertical-align: middle;
  }

  .row table td:last-child {
    border-bottom: none;
  }

  .row table td:before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    color: #007ABC;
    vertical-align: middle;
  }
}

.row table button {
  background-color: transparent;
}
</style>
